import { Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

import { Layout } from '../components/layout';
import { ROUTES } from './routes-map';
import { HomeRoute } from './home';
import { LoginRoute } from './authentication';
import { ProtectedRoute } from '../components/protected-route';

import { ErrorRoute } from './error';
import { PreLoginRoute } from './pre-login';
import { FinanceDataInitRoute } from './finance-data-init';
import { FinanceDataSubmitRoute } from './finance-data-submit';
import { VerificationRoute } from './verification';
import { FinanceDataUploadRoute } from './finance-data-upload';

export function AppRoutes() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path={ROUTES.HOME.path} element={<HomeRoute />} />
                    <Route
                        path={ROUTES.HOME_WITH_TARGET.path}
                        element={<HomeRoute />}
                    />
                    <Route
                        path={ROUTES.PRE_LOGIN.path}
                        element={<PreLoginRoute />}
                    />
                    <Route path={ROUTES.LOGIN.path} element={<LoginRoute />} />
                    <Route
                        path={ROUTES.VERIFICATION.path}
                        element={<VerificationRoute />}
                    />
                    <Route
                        path={ROUTES.FINANCE_DATA_INIT.path}
                        element={<FinanceDataInitRoute />}
                    />
                    <Route
                        path={ROUTES.FINANCE_DATA_UPLOAD.path}
                        element={<FinanceDataUploadRoute />}
                    />
                    <Route
                        path={ROUTES.FINANCE_DATA_SUBMIT.path}
                        element={
                            <ProtectedRoute>
                                <FinanceDataSubmitRoute />
                            </ProtectedRoute>
                        }
                    />
                    <Route path={ROUTES.ERROR.path} element={<ErrorRoute />} />
                    <Route
                        path={ROUTES.ERROR_WITH_TYPE.path}
                        element={<ErrorRoute />}
                    />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}
